import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { freestarQueue } from "./freestar-queue";

const BOTTOM_RAIL = "probuildstats-com_bottom_rail";
const LEFT_RAIL = "probuildstats-com_left_rail"; // Configured in Freestar as a slidewall, so it lives outside our layout.

// pubfig counts the initial page load itself, and filter changes are not new pageviews.
// Module scope so it survives remounts.
let trackedPathname: string | null = null;

// Pubfig creates the sticky footer and slidewall on the first load; on navigation and filter changes they must be
// destroyed and recreated to run a new auction. Both "new" calls no-op when the unit already exists.
// Created one tick late so a redirect that fires in a mount effect does not create, delete, and re-create back to back.
export function FreestarContainer() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    let created = false;
    const timer = setTimeout(() => {
      created = true;
      if (trackedPathname !== null && trackedPathname !== pathname) {
        freestarQueue((freestar) => freestar.trackPageview());
      }
      trackedPathname = pathname;
      freestarQueue((freestar) => freestar.newStickyFooter(BOTTOM_RAIL));
      freestarQueue((freestar) => freestar.newSidewall(LEFT_RAIL));
    });

    return () => {
      clearTimeout(timer);
      if (created) {
        freestarQueue((freestar) => freestar.deleteSidewall(LEFT_RAIL));
        freestarQueue((freestar) => freestar.deleteStickyFooter(BOTTOM_RAIL));
      }
    };
  }, [pathname, search]);

  return null;
}
